export default __webpack_public_path__ + "static/media/juanma-freire-1@3x.6204eb59.png";